import styles from "./FormulationPage.module.css";
import Formulations from "../../components/Formulations/Formulations";

export default function FormulationsPage() {
  return (
    <div className={styles.page}>
      <Formulations />
    </div>
  );
}
